import { isNumeric } from '@cutwise/utils';

import CutwiseAPIClient, {
  HEADER_X_TOTAL_COUNT,
  METHOD_DELETE,
  METHOD_GET,
  METHOD_PATCH,
  METHOD_PUT,
} from '@/common/network/CutwiseAPIClient';
import { AccessTargetType } from '@/security/types/AccessTarget';
import { GlobalAccessRequest } from '@/security/types/GlobalAccess';
import { PrivateAccessUpdateResult } from '@/security/types/PrivateAccessUpdateResult';

import { AccessEntry } from '../entities/AccessEntry';
import { AccessRequestDto } from '../entities/AccessRequest';
import { ContactModel } from '../entities/Contact';

export const PATH_SECURITY_ACCESS = 'api/security/access';
export const PATH_SECURITY_ACL_V3 = 'api/v3/security/acl';

export default class SecurityAPI {
  async getAssignees(
    searchQuery?: string,
    offset: Nullable<number> = null,
    limit: Nullable<number> = null,
  ): Promise<{ assignees: ContactModel[]; totalCount: Nullable<number> }> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_SECURITY_ACL_V3}/search`)
      .offset(offset)
      .limit(limit)
      .addQueryStringParam('searchQuery', searchQuery);

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());
    const totalCount = res.networkResponse?.headers.get(HEADER_X_TOTAL_COUNT);

    return {
      assignees: res.content,
      totalCount: isNumeric(totalCount) ? +totalCount : null,
    };
  }

  async getAccessEntries(ids: StringOrNumber[], targetType: AccessTargetType): Promise<AccessEntry[]> {
    const type = targetType === 'driveProject' ? 'driveNode' : targetType;

    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_GET)
      .path(`${PATH_SECURITY_ACL_V3}/${type}`)
      .addQueryStringParam('id', ids);

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());

    return res.content;
  }

  updateAccess(data: GlobalAccessRequest[]) {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_PATCH).path(PATH_SECURITY_ACCESS).body(data);

    return CutwiseAPIClient.sendQuery(qb.getQuery());
  }

  async updateACL(accessRequests: AccessRequestDto[]): Promise<AccessEntry[]> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_PUT)
      .path(PATH_SECURITY_ACL_V3)
      .body({ aclRequests: accessRequests });

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());

    return res.content;
  }

  async deleteACL(accessRequests: AccessRequestDto[]): Promise<PrivateAccessUpdateResult[]> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_DELETE)
      .path(PATH_SECURITY_ACL_V3)
      .body(accessRequests);

    const res = await CutwiseAPIClient.sendQuery(qb.getQuery());

    return res.content;
  }
}
